import React, { Component, Fragment } from "react";
import { getTranskrip, SemesterTranskip, DataTranskrip } from '../../../services/api-services/transkrip-api';
import { Link } from "react-router-dom";

class Transkrip extends Component {
    state = {
        dataMhs: [],
        semester: [],
        listTranskrip: [],
        listBagiTranskrip: [],
        listD: [],
        listE: []
    };

    getDataMahasiswa = async () => {
        const res = await DataTranskrip(localStorage.getItem('nim'))
        if (res) {
            this.setState({ dataMhs: res.data })
        }
    }

    getSemesterTranskrip = async () => {
        const res = await SemesterTranskip(localStorage.getItem('nim'))
        if (res) {
            this.setState({ semester: res.data })
        }
    }

    handleTranskrip = async (e) => {
        let data = {
            nim: localStorage.getItem('nim'),
            semester: e.target.value,
            kurikulum: this.state.dataMhs.kurikulum ?? ""
        }
        const res = await getTranskrip(data)
        if (res) {
            this.setState({
                listTranskrip: res.data.data.map((val, idx) => ({ no: idx + 1, ...val })),
                totalsks: res.data.totalsks,
                totalSKsN: res.data.totalsksn,
                ipk: res.data.ipk,
                totalD: res.data.nilai_d,
                listD: res.data.list_d,
                totalE: res.data.nilai_e,
                listE: res.data.list_e,
                predikat: res.data.predikat
            }, () => {
                this.splitInto2()
            })
        }
    }

    splitInto2 = () => {
        let json1 = [];
        let json2 = [];
        let data = this.state.listTranskrip;
        let hasilBagi = Math.round(parseInt(data.length) / 2);
        for (let i = 0; i < data.length; i++) {
            if (data[i].no <= hasilBagi) {
                json1.push(data[i]);
            } else {
                json2.push(data[i]);
            }
        }
        json1.map(function (json, key) {
            json["matched"] = json2[key];
        });
        this.setState({
            listBagiTranskrip: json1
        })
    };

    componentDidMount() {
        this.getSemesterTranskrip()
        this.getDataMahasiswa()
    };

    render() {
        return (
            <div>
                <Fragment>
                    <div className="col-md-12 mb-3">
                        <div className="row">
                            <div className="col-12 col-xl-8 mb-xl-0">
                                <p
                                    className="abu"
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        color: "#999999",
                                        textTransform: "capitalize",
                                    }}
                                >
                                    Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data
                                    Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp; Transkrip
                                </p>
                            </div>
                            <div className="col-12 col-xl-4 sm-md-none">
                                <div className="justify-content-end d-flex ">
                                    <div
                                        style={{ cursor: "pointer" }}
                                        title="expand/minimize"
                                        id="toogleMenu"
                                    >
                                        <i className="fa fa-expand abu" id="iconQ"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" id="smoothMain">

                        <div className="col-xl-12" id="kontenKiri">
                            <div className="card card-custom">
                                <div className="card-body">
                                    <p
                                        className="card-title text-center"
                                        style={{
                                            fontSize: "25px",
                                            marginTop: "10px",
                                            marginBottom: "35px",
                                        }}
                                    >
                                        Transkrip Mahasiswa
                                    </p>

                                    <div className="table-responsive pl-2 pr-2">
                                        <table
                                            className="display expandable-table tableBord table-striped"
                                            style={{ width: "100%" }}
                                        >
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td>NIM</td>
                                                    <td> : </td>
                                                    <td>{this.state.dataMhs.nim}</td>

                                                    <td>Angkatan</td>
                                                    <td> : </td>
                                                    <td>{this.state.dataMhs.angkatan}</td>
                                                </tr>
                                                <tr>
                                                    <td>Nama</td>
                                                    <td> : </td>
                                                    <td>{this.state.dataMhs.nama}</td>

                                                    <td>Semester</td>
                                                    <td> : </td>
                                                    <td>
                                                        <select name="selectSemester" onChange={this.handleTranskrip} className="form-control custom-width" required>
                                                            <option value="" hidden>- Pilih Semester -</option>
                                                            {
                                                                this.state.semester.map((list, i) => {
                                                                    return (
                                                                        <option key={i} value={list.semester}>Semester {list.semester}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="dropdown mt-4 mb-3 pr-2 pl-2">
                                        <button
                                            className="btn btn-success dropdown-toggle"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <i className="fa fa-print"></i>&nbsp;&nbsp;Cetak PDF
                                        </button>
                                        <div
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                        >
                                            <Link className="dropdown-item"
                                                to={{
                                                    pathname: `/printtranskripsementara`,
                                                    state: {
                                                        list: this.state.listBagiTranskrip,
                                                        totalsks: this.state.totalsks,
                                                        totalSKsN: this.state.totalSKsN,
                                                        ipk: this.state.ipk,
                                                        totalD: this.state.totalD,
                                                        listD: this.state.listD,
                                                        totalE: this.state.totalE,
                                                        listE: this.state.listE,

                                                        nama: this.state.dataMhs.nama,
                                                        nim: this.state.dataMhs.nim,

                                                        jurusan: this.state.dataMhs.jurusan,
                                                        fakultas: this.state.dataMhs.fakultas,

                                                        ttl: this.state.dataMhs.ttl,

                                                        namadekan: this.state.dataMhs.dekan,
                                                        nidndekan: this.state.dataMhs.nidn_dekan,

                                                        angkatan: this.state.dataMhs.angkatan
                                                    }
                                                }}
                                            >
                                                <i className="fa fa-print"></i>&nbsp;&nbsp;Transkrip
                                                Sementara
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="table-responsive pl-2 pr-2 mt-4">
                                        <div
                                            className="alert alert-warning mt-3 mb-3"
                                            role="alert"
                                            style={{
                                                fontWeight: 'bold',
                                                fontSize: '15px',
                                                borderLeft: '6px solid #856404',
                                                backgroundColor: '#fff3cd'
                                            }}
                                        >
                                            ⚠️ <b>KETERANGAN NILAI</b><br />
                                            <b>BT</b> = <span style={{ color: '#d39e00' }}>Belum Tampil</span><br />
                                            Nilai mata kuliah belum dipublikasikan oleh dosen.
                                        </div>
                                        <table
                                            className="table-bordered table-transkrip"
                                            style={{ width: "100%", fontSize: "13.3px" }}
                                        >
                                            <thead>
                                                <tr className="header-transkrip">
                                                    <th width="50px">
                                                        <center>No</center>
                                                    </th>
                                                    <th width="600px">
                                                        <center>Mata Kuliah</center>
                                                    </th>
                                                    <th width="70px">
                                                        <center>SKS</center>
                                                    </th>
                                                    <th width="70px">
                                                        <center>Nilai</center>
                                                    </th>
                                                    <th width="70px">
                                                        <center>Bobot</center>
                                                    </th>
                                                    <th width="70px">
                                                        <center>SKS x Bobot</center>
                                                    </th>

                                                    <th width="50px">
                                                        <center>No</center>
                                                    </th>
                                                    <th width="600px">
                                                        <center>Mata Kuliah</center>
                                                    </th>
                                                    <th width="70px">
                                                        <center>SKS</center>
                                                    </th>
                                                    <th width="70px">
                                                        <center>Nilai</center>
                                                    </th>
                                                    <th width="70px">
                                                        <center>Bobot</center>
                                                    </th>
                                                    <th width="70px">
                                                        <center>SKS x Bobot</center>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.listBagiTranskrip.map((list, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className="no-transkrip">
                                                                <center>{list.no}</center>
                                                            </td>
                                                            <td>{list.matakuliah}</td>
                                                            <td>
                                                                <center>{list.sks}</center>
                                                            </td>
                                                            <td>
                                                                <center>{list.grade}</center>
                                                            </td>
                                                            <td>
                                                                <center>{list.nilai}</center>
                                                            </td>
                                                            <td>
                                                                <center>{list.sksn}</center>
                                                            </td>
                                                            {
                                                                list.matched == undefined ?
                                                                    <>
                                                                        <td className="no-transkrip">
                                                                            <center>&nbsp;</center>
                                                                        </td>
                                                                        <td></td>
                                                                        <td>
                                                                            <center></center>
                                                                        </td>
                                                                        <td>
                                                                            <center></center>
                                                                        </td>
                                                                        <td>
                                                                            <center></center>
                                                                        </td>
                                                                        <td>
                                                                            <center></center>
                                                                        </td>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <td className="no-transkrip">
                                                                            <center>{list.matched.no}</center>
                                                                        </td>
                                                                        <td>{list.matched.matakuliah}</td>
                                                                        <td>
                                                                            <center>{list.matched.sks}</center>
                                                                        </td>
                                                                        <td>
                                                                            <center>{list.matched.grade}</center>
                                                                        </td>
                                                                        <td>
                                                                            <center>{list.matched.nilai}</center>
                                                                        </td>
                                                                        <td>
                                                                            <center>{list.matched.sksn}</center>
                                                                        </td>
                                                                    </>
                                                            }
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                        <table className="table-footer mt-4 mb-4">
                                            <tbody>
                                                <tr>
                                                    <td>Total NA x SKS </td>
                                                    <td width='50px'></td>
                                                    <td>:</td>
                                                    <td width='10px'></td>
                                                    <td>{this.state.totalSKsN}</td>
                                                </tr>
                                                <tr>
                                                    <td>Jumlah SKS </td>
                                                    <td width='50px'></td>
                                                    <td>:</td>
                                                    <td width='10px'></td>
                                                    <td>{this.state.totalsks}</td>
                                                </tr>
                                                <tr>
                                                    <td>IP Kumulatif </td>
                                                    <td width='50px'></td>
                                                    <td>:</td>
                                                    <td width='10px'></td>
                                                    <td>{this.state.ipk}</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <br />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Total Nilai D </td>
                                                    <td width='50px'></td>
                                                    <td>:</td>
                                                    <td width='10px'></td>
                                                    <td>{this.state.totalD} Mata Kuliah</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={4}></td>
                                                    <td>
                                                        {
                                                            this.state.listD.map((list, i) => {
                                                                return (
                                                                    <p>{i + 1}. {list}</p>
                                                                )
                                                            })
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Total Nilai E </td>
                                                    <td width='50px'></td>
                                                    <td>:</td>
                                                    <td width='10px'></td>
                                                    <td>{this.state.totalE} Mata Kuliah</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={4}></td>
                                                    <td>
                                                        {
                                                            this.state.listE.map((list, i) => {
                                                                return (
                                                                    <p>{i + 1}. {list}</p>
                                                                )
                                                            })
                                                        }
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            </div>
        );
    }
}

export default Transkrip;
